module.exports = __webpack_public_path__ + "img/Bucher & Zeitschriften.f386655c.jpg";